goog.provide("shadow.js.shim.module$date_fns$format$default");
shadow.js.shim.module$date_fns$format$default = esm_import$date_fns$format.default;
